<template>
  <div class="webauthn-register">
    <div v-if="error" class="error">{{ error }}</div>
    <div v-if="success" class="success">{{ success }}</div>
    <button @click="register" :disabled="isRegistering">
      {{ isRegistering ? 'Registering...' : 'Register Device' }}
    </button>
  </div>
</template>

<script>
import { startRegistration } from '@simplewebauthn/browser';
import api from '@/services/api';

export default {
  name: 'WebAuthnRegister',
  props: {
    brand_id: undefined,
    username: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isRegistering: false,
      error: '',
      success: ''
    };
  },
  methods: {
    async register() {
      this.isRegistering = true;
      this.error = '';
      this.success = '';

      try {
        // Get registration options from server
        const optionsResponse = await api.getRegistrationOptions(this.username,["SB3", "SB4", "SB5"].includes(this.brand_id) ? "SB2" : this.brand_id);

        // Start registration process in browser
        const attResp = await startRegistration(optionsResponse.data);

        // Send response to server for verification
        const verificationResponse = await api.verifyRegistration(this.username, attResp,["SB3", "SB4", "SB5"].includes(this.brand_id) ? "SB2" : this.brand_id);

        if (verificationResponse.data.verified) {
          this.success = 'Registration successful!';
          this.$emit('registration-complete');
        } else {
          this.error = 'Registration failed. Please try again.';
          this.$emit('registration-error', this.error);
        }
      } catch (error) {
        console.error(error);
        
        // Extract error message with priority for rate limiting
        let errorMessage = 'Registration failed';
        
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || error.response.data.error || errorMessage;
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        this.error = errorMessage;
        this.$emit('registration-error', this.error);
      } finally {
        this.isRegistering = false;
      }
    }
  }
};
</script>

<style scoped>
.error {
  color: red;
  margin-bottom: 10px;
}
.success {
  color: green;
  margin-bottom: 10px;
}
button {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 4px;
}
button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
